/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { RouteHelper } from "@nf/common";
import { DefaultSeo } from "next-seo";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { fallbackPageMetadata } from "./pageMetadata";

export const DefaultSEO = () => {
  const router = useRouter();
  const { t } = useTranslation("translations");
  const href = process.env.NEXT_PUBLIC_MAIN_DOMAIN + router.asPath;

  const landingPageTabTitle =
    !router.query.id &&
    t("web_seo_cta_title_tags_landing_page", process.env.NEXT_PUBLIC_NAME);

  const tagTitle = landingPageTabTitle || process.env.NEXT_PUBLIC_NAME;

  const canonicalUrl = RouteHelper.getCountryCanonicalUrl(
    router.pathname,
    router.query
  );

  return (
    <DefaultSeo
      title={tagTitle}
      titleTemplate={`%s`}
      canonical={canonicalUrl}
      defaultTitle={process.env.NEXT_PUBLIC_NAME}
      description={fallbackPageMetadata.default.description}
      additionalMetaTags={[
        {
          name: "viewport",
          content: "width=device-width, initial-scale=1, shrink-to-fit=no",
        },
        {
          name: "keywords",
          content: "movie, series, film, video",
        },
      ]}
      openGraph={{
        title: tagTitle,
        description: fallbackPageMetadata.default.description,
        type: "website",
        url: href,
        site_name: process.env.NEXT_PUBLIC_NAME,
        images: [{ url: "/assets/app/app-header-logo.png" }],
      }}
    />
  );
};

export default DefaultSEO;
